
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 1.944h18v-1H0zm0 6h18v-1H0zm0 7h18v-1H0z","fill":"#FFF"}}),_c('path',{attrs:{"fill":"currentColor","d":"M4.932 15.686c-.838 0-1.517-.643-1.517-1.435 0-.793.68-1.436 1.517-1.436.838 0 1.517.643 1.517 1.436 0 .792-.68 1.435-1.517 1.435"}}),_c('path',{attrs:{"fill":"#FFF","d":"M4.932 13.073c-.686 0-1.244.528-1.244 1.177 0 .65.558 1.178 1.244 1.178.686 0 1.244-.528 1.244-1.178 0-.649-.558-1.177-1.244-1.177m0 2.87c-.987 0-1.79-.759-1.79-1.693 0-.933.803-1.693 1.79-1.693s1.79.76 1.79 1.693c0 .934-.803 1.694-1.79 1.694"}}),_c('path',{attrs:{"fill":"currentColor","d":"M12.68 9.073c-.837 0-1.517-.643-1.517-1.435 0-.793.68-1.436 1.517-1.436.838 0 1.517.643 1.517 1.436 0 .792-.679 1.435-1.517 1.435"}}),_c('path',{attrs:{"fill":"#FFF","d":"M12.68 6.46c-.686 0-1.244.528-1.244 1.177 0 .65.558 1.178 1.244 1.178.686 0 1.244-.528 1.244-1.178 0-.649-.558-1.177-1.244-1.177m0 2.87c-.987 0-1.79-.759-1.79-1.693 0-.933.803-1.693 1.79-1.693.988 0 1.79.76 1.79 1.693 0 .934-.802 1.694-1.79 1.694"}}),_c('path',{attrs:{"fill":"currentColor","d":"M6.103 3.128c-.837 0-1.517-.642-1.517-1.435S5.266.258 6.103.258C6.941.258 7.62.9 7.62 1.693s-.679 1.435-1.517 1.435"}}),_c('path',{attrs:{"fill":"#FFF","d":"M6.102.516c-.686 0-1.244.528-1.244 1.177 0 .65.558 1.177 1.244 1.177.687 0 1.245-.528 1.245-1.177 0-.65-.558-1.177-1.245-1.177m0 2.87c-.987 0-1.79-.76-1.79-1.693C4.312.759 5.115 0 6.102 0c.988 0 1.79.76 1.79 1.693 0 .934-.802 1.694-1.79 1.694"}})])
          )
        }
      }
    